import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { Scene } from './Scene';
import { Renderer } from './Renderer';
import { Env } from './Env';

export class Lights {

    static envMap: THREE.Texture;
    static envMapIntensity: number;
    static PMREMGenerator: THREE.PMREMGenerator;

    constructor() {
        // this.directionalLight();
        this.hemiLight();
        // this.rgbe();
        // this.setPMREMGenerator();
    }

    rgbe() {
        new RGBELoader().load(`${Env.base_url}static/corps/blocky_photo_studio_1k.hdr`, function (texture) {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            Lights.envMap = texture;
            Lights.envMapIntensity = 1.2;
            Lights.setPMREMGenerator(texture);
            Scene.scene.environment = texture;
        });
    }

    directionalLight() {
        const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
        // directionalLight.color.setHSL(.25, .05, .9);
        directionalLight.position.set(10, 100, 50);
        // directionalLight.position.multiplyScalar(30);
        // directionalLight.castShadow = true;
        // directionalLight.shadow.mapSize.width = renderer.capabilities.maxTextureSize / 4;
        // directionalLight.shadow.mapSize.height = renderer.capabilities.maxTextureSize / 4;
        directionalLight.shadow.bias = - .0001;
        Scene.scene.add(directionalLight);
    
        // const dirLightHelper = new THREE.DirectionalLightHelper(directionalLight, 10);
        // Scene.scene.add(dirLightHelper);
    }

    hemiLight() {
        const hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffcc, 1);
        hemiLight.color.setHSL(.25, .05, .9);
        hemiLight.groundColor.setHSL(.25, .05, 1);
        hemiLight.position.set(0, 100, 0);
        Scene.scene.add(hemiLight);
    
        // const hemiLightHelper = new THREE.HemisphereLightHelper(hemiLight, 10);
        // scene.add(hemiLightHelper);
    }

    static setPMREMGenerator(texture) {
        const PMREMGenerator = new THREE.PMREMGenerator(Renderer.renderer);
        PMREMGenerator.fromScene(Scene.scene);
        // Scene.scene.background = texture;
        // PMREMGenerator.fromEquirectangular(texture);
        // PMREMGenerator.compileEquirectangularShader();
        Lights.PMREMGenerator = PMREMGenerator;
    }


}